import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { RetailIndustryPage } from "@/components/site/RetailIndustryPage";
import { RETAIL_META_DESCRIPTION } from "@/content/meta/RetailIndustryPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/industries/retail")({
  head: () => ({
    meta: [
      { title: "Retail Media Monitoring & Analysis | Perceptica" },
      { name: "description", content: RETAIL_META_DESCRIPTION },
      { property: "og:title", content: "Retail Media Monitoring & Analysis | Perceptica" },
      { property: "og:description", content: RETAIL_META_DESCRIPTION },
      { name: "twitter:title", content: "Retail Media Monitoring & Analysis | Perceptica" },
      { name: "twitter:description", content: RETAIL_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/industries/retail" },
      ...ogImageMeta("en", "/industries/retail"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/industries/retail" }),
  }),
  component: RetailIndustryPage,
});
